module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_10_50.a7ddc2ce.png";